export const SET_TRANSFER = "SET_TRANSFER";
export const SET_TRANSFERS = "SET_TRANSFERS";
